import { Link } from "react-router-dom";
import { MapPin, Clock, Store, Heart } from "lucide-react";
import { useT } from "../lib/i18n";
import { fmtDate } from "../lib/options";

export function JobCard({ job, saved, onToggleSave }) {
  const { t, lang } = useT();
  const org = job.organizations || {};
  return (
    <div className="card-soft relative flex flex-col gap-3 p-5 transition-shadow hover:shadow-md fade-up" data-testid={`job-card-${job.id}`}>
      <Link to={`/jobs/${job.id}`} className="absolute inset-0 rounded-2xl" aria-label={job.title} data-testid={`job-card-link-${job.id}`} />
      <div className="flex items-start gap-3">
        {org.logo_url ? <img src={org.logo_url} alt="" className="h-12 w-12 rounded-xl border object-cover" loading="lazy" /> : <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-slate-100 text-[color:var(--navy)]"><Store size={22} /></span>}
        <div className="min-w-0 flex-1">
          <h3 className="text-lg font-bold leading-snug text-slate-900">{job.title}</h3>
          <p className="truncate text-slate-600">{org.name}</p>
        </div>
        {onToggleSave && (
          <button onClick={() => onToggleSave(job.id)} className="relative z-10 grid h-12 w-12 place-items-center rounded-full hover:bg-slate-100" aria-label={saved ? t("unsave_job") : t("save_job")} data-testid={`job-save-btn-${job.id}`}>
            <Heart size={24} className={saved ? "fill-[color:var(--orange)] text-[color:var(--orange)]" : "text-slate-400"} />
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2 text-sm font-semibold">
        <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-slate-700"><MapPin size={14} />{job.branch ? `${job.branch}, ` : ""}{job.location}</span>
        <span className="inline-flex items-center gap-1 rounded-full bg-[color:var(--orange-soft)] px-3 py-1 text-[color:var(--orange-dark)]">{t(`cat_${job.category}`)}</span>
        {(job.hours || []).slice(0, 2).map((h) => <span key={h} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-slate-700"><Clock size={14} />{t(`h_${h}`)}</span>)}
        {job.experience === "none" && <span className="rounded-full bg-emerald-50 px-3 py-1 text-emerald-700">{t("e_none_job")}</span>}
      </div>
      <div className="flex items-center justify-between text-sm text-slate-500">
        <span>{job.salary}</span>
        <span>{fmtDate(job.created_at, lang)}</span>
      </div>
    </div>
  );
}
